import React from 'react'
import { Tooltip } from 'antd'
import './index.css'

interface IconButtonWhiteProps {
  iconUrl?: string;
  width?: string;
  height?: string;
  iconColor?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  tooltipText?: string;
}

const IconButtonWhite: React.FC<IconButtonWhiteProps> = ({
  iconUrl,
  width = '48px',
  height = '48px',
  iconColor = '#A4A7AE',
  style = {},
  onClick = () => {},
  disabled = false,
  className = '',
  tooltipText = '',
}) => {
  const button = (
    <button
      className={`icon-button-white ${className}`}
      style={{
        width,
        height,
        ...style,
      }}
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      {iconUrl && (
        <div
          className="icon-button-white-icon"
          style={{
            WebkitMaskImage: `url(${iconUrl})`,
            maskImage: `url(${iconUrl})`,
            WebkitMaskSize: 'contain',
            maskSize: 'contain',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
            backgroundColor: iconColor,
          }}
        />
      )}
    </button>
  )

  return tooltipText ? <Tooltip title={tooltipText}>{button}</Tooltip> : button
}

export default IconButtonWhite
